/**
 * RequireStaff — staff-only route guard (app_admin, org_admin, coach).
 *
 * Thin wrapper over RequireRole; re-validates the session with the auth server
 * so a stale client flag can never flash staff UI.
 */
import { ReactNode } from "react";
import { RequireRole } from "./RequireRole";
import type { UserRole } from "@/hooks/useUserRole";

/** Roles considered "staff" for MVP staff pages. */
export const STAFF_ROLES: UserRole[] = ["app_admin", "org_admin", "coach"];

export function RequireStaff({
  children,
  allowedRoles = STAFF_ROLES,
}: {
  children: ReactNode;
  allowedRoles?: UserRole[];
}) {
  return (
    <RequireRole
      allowedRoles={allowedRoles}
      verifySession
      deniedRedirect="/app/home"
      deniedMessage="Staff access required"
    >
      {children}
    </RequireRole>
  );
}

export default RequireStaff;
